import React from "react";
import {Helmet} from "react-helmet";
import Ivan1 from "../../assets/images/SteamSteelInfiniteMind/ivan-1.jpeg";
import Ivan2 from "../../assets/images/SteamSteelInfiniteMind/ivan-2.jpeg";
import Ivan3 from "../../assets/images/SteamSteelInfiniteMind/ivan-3.jpeg";
import Ivan4 from "../../assets/images/SteamSteelInfiniteMind/ivan-4.jpeg";
import Ivan5 from "../../assets/images/SteamSteelInfiniteMind/ivan-5.jpeg";
import Ivan6 from "../../assets/images/SteamSteelInfiniteMind/ivan-6.jpeg";
import Ivan7 from "../../assets/images/SteamSteelInfiniteMind/ivan-7.jpeg";
import Ivan8 from "../../assets/images/SteamSteelInfiniteMind/ivan-8.jpeg";
import Ivan9 from "../../assets/images/SteamSteelInfiniteMind/ivan-9.jpeg";
import Ivan10 from "../../assets/images/SteamSteelInfiniteMind/ivan-10.jpeg";
import Ivan11 from "../../assets/images/SteamSteelInfiniteMind/ivan-11.jpeg";

export default function SteamSteelInfiniteMind() {
    return (
        <div>
            <Helmet>
                <title>[文]蒸汽，钢铁和无限心智 Steam, Steel, and Infinite Minds</title>
            </Helmet>
            <h6 className="App-essay-title">[文]蒸汽，钢铁和无限心智</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 十二月</b>
                <br/><br/>
                <i style={{ color: 'grey' }}>
                    Ivan的文章充满了设计、建筑、城市、影像和公司史的比喻，很生动。已尽我所能，保留Ivan的行文特征：排版、语调、文字加粗、特殊用词，并在翻译中尽量减少我的个人偏好。<br/><br/>
                    Enjoy-
                </i>
                <br/><br/>
                <b>
                    <a href="https://www.notion.com/blog/steam-steel-and-infinite-minds-ai" rel="noreferrer noopener" target="_blank">原文：Steam, Steel, and Infinite Minds.</a><br/>
                    作者：Ivan Zhao, Co-founder & CEO of Notion
                </b>
                <hr/>
                每个时代，都被那个时代的神奇材料塑造。钢铁锻造了镀金时代（Gided Age）。半导体开启了数字时代。而如今，AI作为无限心智（Infinite Minds）降临了。如果历史教会过我们任何事，那就是，谁掌握了时代材料，谁就定义时代。
                <br/><br/>
                <img src={Ivan1} alt="Andrew Carnegie" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>左：少年时代的安德鲁·卡内基与其弟弟。<br/>右：镀金时代的匹兹堡钢铁工厂。</i>
                <br/><br/>
                19世纪50年代，安德鲁·卡内基还是匹兹堡街头泥泞中奔走的电报小子。那时十个美国人里有六个是农民。两代人过去，卡内基和他的同辈们锻造了现代世界。马车让位于铁路，烛火让位于电灯，铁让位于钢。
                <br/><br/>
                自那以后，工作从工厂转移到办公室。今天，我在旧金山经营一家软件公司，为数以百万计的知识工作者打造工具。在这座产业之城里，人人都在谈论AGI（通用人工智能），但大多数二十亿桌面办公者尚未切身体会。知识工作很快会变成什么样？当组织结构图（org chart）吸纳进一个永不休眠的心智（minds），会发生什么？
                <br/><br/>
                <img src={Ivan2} alt="Early Film" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>早期电影常常像舞台剧，把一台摄影机对准了舞台。</i>
                <br/><br/>
                未来之所以难以预见，因为它总把自己伪装成过去。早期的电话像电报一样简短；早期的电影像把戏剧拍成影像。<b>（这正是马歇尔·麦克卢汉 Marshall McLuhan 所说的“我们总是透过后视镜驶入未来”。）</b>
                <br/><br/>
                <img src={Ivan3} alt="openai-google" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>当下最受欢迎的AI形态，看起来像过去的谷歌搜索。引用马歇尔·麦克卢汉的话：“我们总是透过后视镜驶入未来。”</i>
                <br/><br/>
                今天，我们把它看作模仿谷歌搜索框的AI聊天机器人。我们正深处每一次技术范式迁移都会经历的那段令人不适的过渡期。
                <br/><br/>
                下一步会发生什么，我没有全部答案。但我喜欢借用一些历史隐喻，来思考AI如何在不同尺度上工作：从个人，到组织，再到整个经济体。
                <br/><br/><br/>
                <h5><b>个人：从自行车到汽车</b></h5>
                <br/>
                最初的影子，可以从知识工作的“大祭司”——程序员身上看到。
                <br/><br/>
                我的联合创始人Simon曾是我们所谓的“10x倍程序员”，但他如今很少亲自写代码。走过他的工位，你会看到他同时编排三四个AI编程代理（coding agents）。它们不只是打字更快，还会思考，这让他总体上成为“30～40×倍工程师”。他会在午饭或睡前安排好任务队列，让它们在自己离开时继续工作。他已经变成了无限心智（Infinite Minds）的管理者。
                <br/><br/>
                <img src={Ivan4} alt="Mind Bicycle" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>上世纪70年代，《科学美国人》关于运动效率的一项研究启发了史蒂夫·乔布斯著名的“思维的自行车”隐喻。只不过自那以后，我们在“信息高速公路”上蹬了几十年自行车。</i>
                <br/><br/>
                20世纪80年代，乔布斯称个人电脑是“思维的自行车”。十年后，我们铺就了互联网这条“信息高速公路”。但直到今天，大多数知识工作仍然靠人力驱动。就像我们一直在不限速高速上骑自行车（autobahn，德国不限速高速）。
                <br/><br/>
                有了AI代理，像Simon这样的人，已经从骑车升级到开车。
                <br/><br/>
                其他类型的知识工作者何时也能开上汽车？必须先解决两个问题。
                <br/><br/>
                <img src={Ivan5} alt="Knowledge Workers" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>相较于编程代理，为什么AI更难帮助一般知识工作？因为知识工作更碎片化，也更难验证。</i>
                <br/><br/>
                <b>第一，上下文碎片化（context fragmentation）。</b>对编程而言，工具和上下文往往集中在一个地方：IDE、代码仓库、终端。但一般知识工作散落在几十种工具中。想象一个AI代理要起草产品方案：它得从Slack聊天记录、战略文档、上季度的仪表盘指标，以及只存在于某人脑海中的“组织记忆”中拉取信息。今天，人类充当胶水，通过复制粘贴、切换浏览器标签把这一切缝合起来。在上下文得到整合之前，代理（agents）只能被困在狭窄的用例里。
                <br/><br/>
                <b>第二，缺少可验证性（verifiability）。</b>代码有个神奇属性：可以用测试和报错来验证。模型构建者利用这一点，训练AI把编程做得更好（例如强化学习）。但你如何验证一个项目是否管理得当，或一份战略备忘录（strategy memo）是否写得好？我们还没有找到方法来改进模型，让它们胜任普遍性的知识工作（general knowledge work）。因此，人类仍需要“介入”（in the loop）来监督、引导，并示范“什么是好”。
                <br/><br/>
                <img src={Ivan6} alt="Red Flag Rule" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>1865年的《红旗法案》要求一名持旗者走在车辆前方为其开道（1896年废除）。这是不理想的“人要介入”的例子。</i>
                <br/><br/>
                今年的编程代理给我们的教训是：“人要介入”并非总是理想的。这就像让人亲自检查流水线上每一颗螺栓，或者走在车前清路一样（参见《红旗法案》）。我们希望人类在更有杠杆的位置上监督流程，而不是被卡在工作流程里。一旦上下文得到整合、工作可被验证，数十亿工作者就会从“蹬车”变为“开车”，再从“开车”变为“自动驾驶”。
                <br/><br/><br/>
                <h5><b>组织：钢与蒸汽</b></h5>
                <br/>
                公司是近代的发明。它们在扩张中退化，然后触及极限。
                <br/><br/>
                <img src={Ivan7} alt="Railroad Org Chart" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>纽约-伊利铁路公司的组织结构图，1855年。现代公司与组织结构图随铁路公司共同演进——铁路公司是最早需要协调成千上万人跨越广阔地域开展工作的企业。</i>
                <br/><br/>
                几百年前，大多数公司不过是十来人的作坊。如今我们有了动辄数十万人的跨国企业。通信基础设施（用会议和消息串联起来的人脑）在指数级的负载下不堪重负。我们试图用等级、流程和文档来解决。但我们一直在用“人类尺度”的工具解决“工业尺度”的问题——好比用木头去盖摩天大楼。
                <br/><br/>
                两个历史隐喻揭示了，当我们拥有新的神奇材料，未来的组织会有何不同。
                <br/><br/>
                <img src={Ivan8} alt=" Wonder of Steel" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>钢铁奇观：纽约伍尔沃斯大厦，1913年竣工时为世界最高建筑。</i>
                <br/><br/>
                第一个是钢。在钢出现之前，19世纪的建筑高度极限大约是六七层。铁虽坚固，却脆且重；再加层数，建筑会被自身重量压垮。钢改变了一切。它既强韧又有延展性。结构可以更轻，墙体可以更薄，高楼突然拔地而起，达几十层之上。全新类型的建筑因此成为可能。
                <br/><br/>
                <b>AI之于组织，如钢之于建筑。</b>它有潜力跨工作流维持上下文，适时呈现决策而不过度打扰。人类沟通不必再充当承重墙。每周两小时的对齐会，变成五分钟的异步评审。本该经过三级审批的高层决策，很快也许几分钟就能完成。公司可以扩张——真正地扩张——而不再出现我们曾认为不可避免的组织退化。
                <br/><br/>
                <img src={Ivan9} alt="Wonder of Steel" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>一座由水车驱动的磨坊。水力强大却不稳定，还把磨坊限制在少数地点与季节里。</i>
                <br/><br/>
                第二个故事是蒸汽机。工业革命初期，早期纺织厂依河傍溪而建，以水车为动力。蒸汽机到来时，厂主们最初只是把水车换成蒸汽机，其他一切照旧。生产率提升有限。
                <br/><br/>
                真正的突破，是当厂主意识到他们可以彻底摆脱水源。工厂可以建得更大，更靠近工人、港口和原料。他们围绕蒸汽机重塑工厂布局。（后来，电力出现，厂主进一步摆脱中心传动轴，把小型电机分散到工厂各处，驱动不同的机器。）生产率飙升，第二次工业革命由此真正起飞。
                <br/><br/>
                <img src={Ivan10} alt="a textile factory in Lancashire, UK" className={"App-home-image"}/>
                <i style={{ color: 'grey' }}>托马斯·阿洛姆 Thomas Allom 1835年的版画，描绘了英国兰开夏郡（Lancashire）一座蒸汽驱动的纺织厂。</i>
                <br/><br/>
                我们仍停留在“把水车换掉”的阶段：把AI聊天机器人硬装在现有的工具上。我们尚未重新想象，当旧约束消解、你的公司可以由“无限心智”昼夜运转时，组织会是何种模样。
                <br/><br/>
                在我的公司Notion，我们一直在试验。除了1000名员工之外，如今已有700多个代理在处理重复性工作。它们做会议记录、回答问题、整合部落式的知识（tribal knowledge）。它们处理IT请求，记录客户反馈。它们帮助新人办理入职与员工福利。它们撰写周报，让人们不必再复制粘贴。而这还只是“学步”。真正给收益设限的，只有想象力与惰性。
                <br/><br/><br/>
                <h5><b>经济：从佛罗伦萨到特大城市</b></h5>
                <br/>
                钢与蒸汽改变的不只是建筑与工厂，它们也改变了城市。
                <br/><br/>
                <img src={Ivan11} alt="from Florence to megacities" className={"App-home-image"}/>
                <br/><br/>
                在几百年前，城市依然是“人类尺度”的。你步行四十分钟就能走完佛罗伦萨。生活的节奏由人的步行远近，嗓门大小的传播距离所决定。
                <br/><br/>
                后来，钢架让摩天楼成为可能。蒸汽机为铁路供能，连接起城市中心与腹地。电梯、地铁、高速公路接踵而至。城市在规模与密度上爆发式增长。东京。重庆。达拉斯。
                <br/><br/>
                它们不是放大版的佛罗伦萨，而是另一种生活方式。特大城市令人迷失、陌生、难寻方向。这种模糊难辨是规模化的代价。但它们也提供更多的机会与更大的自由。更多的人，在更多的组合里，做更多的事——远超一座人类尺度的文艺复兴城市所能容纳。
                <br/><br/>
                我认为，知识经济正要经历同样的转变。
                <br/><br/>
                今天，知识工作约占美国GDP的近一半。多数仍以人类尺度运作：几十人的团队，以会议和邮件为节奏的工作流，过了几百人，组织就开始吃力。我们用石头与木头搭出了佛罗伦萨。
                <br/><br/>
                当AI代理大规模上线时，我们将要搭建东京。组织能跨越数千个代理与人类；工作跨越时区持续运行，无需等谁醒来；决策以恰到好处的“需要人介入”被整合完成。
                <br/><br/>
                这会感觉很不一样。速度更快，杠杆更大，但刚开始也会更令人迷失。每周例会、季度规划、年度评审的节奏，或许不再合理。新的节奏会出现。我们会失去一些清晰度，收获规模与速度。
                <br/><br/><br/>
                <h5>超越水车</h5>
                <br/>
                每一种神奇材料都要求人们停止从后视镜里看世界，开始去想象一个新的世界。卡内基望向钢铁，看到的是城市天际线。兰开夏郡的工厂主看着蒸汽机，看到的是不必再傍水而建的厂房平面。
                <br/><br/>
                我们仍处在AI的水车阶段，把聊天机器人拴在为人类设计的工作流上。我们需要停止把AI仅仅当作副驾（Copilot）。我们要去想象：当人类组织由“钢”加固，当繁重琐事交给永不休眠的心智时，知识工作会变成什么样。
                <br/><br/>
                钢，蒸汽，无限心智。下一片天际线，正等着我们去建造。


            </p>

            <br/>

            <h6 className="App-essay-title">Steam, Steel, and Infinite Minds</h6>
            <p className="App-essay-article">
                <br/>
                <b>Dec 2025</b>
                <br/><br/>


            </p>
        </div>)
}
